import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LoaformService } from '../RestServices/loaform.service';
import { loaformObj } from '../objects/loaformObj';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'app-loaform',
    templateUrl: './loaform.component.html',
    styleUrls: ['./loaform.component.css'],
    standalone: false
})
export class LoaformComponent implements OnInit {

  obj: loaformObj = new loaformObj();
  showError: boolean = false;
  resetFlag: boolean = false;
  showErrorMsg = "";
  mainDiv: boolean = true;
  successDiv: boolean = false;
  showDiv: boolean = false;
  infoAlert: boolean = false;
  resultDto: any;
  image: any;
  captchaImage: any;
  privacyNotice: string = 'none';
  enterCaptchaImage: string = "";
  captchaTextDecoded: any;
  errorFields: string[] = [];
  @ViewChild("alertText") alertText: ElementRef;
  isAppInitialized: boolean = false;
  isValidated: boolean = false;
  constructor(private elementRef: ElementRef, private sanitizer: DomSanitizer, private router: Router, private serv: LoaformService) { }


  ngOnInit(): any {
    this.obj = new loaformObj();
    this.captcha();
    this.removeNg();
    setTimeout(() => {
      this.isAppInitialized = true;
    })
  }

  removeNg(): any {
    this.elementRef.nativeElement.removeAttribute("ng-version");
  }

  captcha() {
    this.serv.getCaptchaImage().subscribe((data: any) => {
      let imageData = data.captchaImage;
      // this.captchaImage=data.captchaText;
      this.enterCaptchaImage = data.captchaText;
      let enterCaptchaImage = data.captchaText;

      this.image = this.sanitizer.bypassSecurityTrustUrl("data:Image/*;base64," + imageData);
      // this.captchaTextDecoded = this.sanitizer.bypassSecurityTrustUrl("data:Text/*;base64," + enterCaptchaImage);
      this.captchaTextDecoded = atob(enterCaptchaImage);

    })
    this.speak("end");

  }

  speak(flag: string) {
    window.speechSynthesis.cancel();
    if ('speechSynthesis' in window) {
      if (flag == "end") {
        window.speechSynthesis.cancel();
      } else {
        for (let i = 0; i < this.captchaTextDecoded.length; i++) {
          let letter: any = this.captchaTextDecoded[i];
          if (!isNaN(letter)) {
          } else if (letter === letter.toUpperCase()) {
            letter = 'capital ' + letter;
          } else if (letter === letter.toLowerCase()) {
            letter = 'small ' + letter;
          }
          const utterance = new SpeechSynthesisUtterance(letter);
          utterance.rate = 0.5;
          window.speechSynthesis.speak(utterance);
        }
      }

    } else {
      alert('Sorry, your browser does not support audio captcha.');
    }
  }


  testRest(input: any) {

    this.serv.testRestService(input).subscribe((data) => {

      // console.log("THE DATA FETCHED FROM SERVER SIDE==>>",data.body)
    })

  }




  ValidateForm() {
    this.isValidated = true;
    this.hideError();
    this.speak("end");
    // this.validate("Namee",0);
    this.showError = false; //Added by Nikhil for Error Message update for Screen Reader
    // document.getElementById('Namee').style.backgroundColor="#FFB280";
    document.getElementById('Namee').style.backgroundColor = "#FFFFFF";
    document.getElementById("CompanyInputId").style.backgroundColor = "#FFFFFF";
    document.getElementById("MailId").style.backgroundColor = "#FFFFFF";
    document.getElementById("CountryInputId").style.backgroundColor = "#FFFFFF";
    document.getElementById("PhoneNoInputId").style.backgroundColor = "#FFFFFF";
    document.getElementById("LoaInputId").style.backgroundColor = "#FFFFFF";
    document.getElementById("LoaHolderInputId").style.backgroundColor = "#FFFFFF";
    document.getElementById("ExampleFormControlTextarea1").style.backgroundColor = "#FFFFFF";
    document.getElementById("EnterCaptchaInputId").style.backgroundColor = "#FFFFFF";


    this.serv.validateLOAService(this.obj).subscribe({next:(data: any) => {
      console.log("Validation Response from Server==>>", data.body);
      let refreshFlag = 1;
      if (data.body.result == "BUFFERFAIL") {
        this.captcha();
        alert("Something Went Wrong..!!");
        return;
      }

      if (data.body.result == "onlyNumber" || this.validate("PhoneNoInputId", 0)) {
        this.showError = true;

        if (null != this.obj.phoneNo || this.obj.phoneNo != "") {
          document.getElementById("PhoneNoInputId").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "The format of Phone number entered is incorrect. Only numeric data allowed.";
          // this.moveCursor("PhoneNoInputId");
          this.errorPrint("phoneNoInputIdError", "The format of Phone number entered is incorrect. Only numeric data allowed.");

        }
      }
      if (data.body.result == "LONGPHONENO" || this.validate("PhoneNoInputId", 1)) {
        this.showError = true;
        document.getElementById("PhoneNoInputId").style.backgroundColor = "#FFB280";
        this.showErrorMsg = "Only 100 digits can enter.";
        // this.moveCursor("PhoneNoInputId");
        this.errorPrint("phoneNoInputIdError", "Only 100 digits can enter.");

      }
      if (data.body.result == "onlyNumberCountry" || this.validate("CountryInputId", 0)) {
        this.showError = true;

        if (null != this.obj.countryCode || this.obj.countryCode != "" || (this.obj.countryCode.charAt(0)=='+' && this.obj.countryCode.length>1)) {
          document.getElementById("CountryInputId").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "The format of Country Code entered is incorrect. Only '+' and numeric data allowed.";
          // this.moveCursor("CountryInputId");
          this.errorPrint("countryInputIdError", "The format of Country Code entered is incorrect. Only '+' and numeric data allowed.");


        }
      }
      if (data.body.result == "wrongEmailId" || this.validate("MailId", 1)) {
        this.showError = true;

        if (null != this.obj.emailId || this.obj.emailId != "") {
          document.getElementById("MailId").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "The format of Email id entered is incorrect.";
          // this.moveCursor("MailId");
          this.errorPrint("mailIdError", "The format of Email id entered is incorrect.");

        }

      }
      if (data.body.result == "SpclemailId" || this.validate("MailId", 0)) {
        this.showError = true;
        this.showErrorMsg = "No Special characters allowed.";
        // this.moveCursor("MailId");
        this.errorPrint("mailIdError", "No Special characters allowed.");

        document.getElementById("MailId").style.backgroundColor = "#FFB280";

      }
      if (data.body.result == "Spclname" || this.validate("Namee", 0)) {
        this.showError = true;
        this.showErrorMsg = "No Special characters allowed.";
        // this.moveCursor("Namee");
        this.errorPrint("nameeError", "No Special characters allowed.");

        document.getElementById("Namee").style.backgroundColor = "#FFB280";

      }
      if (data.body.result == "Spclcompany" || this.validate("CompanyInputId", 0)) {
        this.showError = true;
        this.showErrorMsg = "No Special characters allowed.";
        // this.moveCursor("CompanyInputId");
        this.errorPrint("companyInputIdError", "No Special characters allowed.");

        document.getElementById("CompanyInputId").style.backgroundColor = "#FFB280";

      }
      if (data.body.result == "SpclholderName" || this.validate("LoaHolderInputId", 0)) {
        this.showError = true;
        this.showErrorMsg = "No Special characters allowed.";
        // this.moveCursor("LoaHolderInputId");
        this.errorPrint("loaHolderInputIdError", "No Special characters allowed.");

        document.getElementById("LoaHolderInputId").style.backgroundColor = "#FFB280";


      }
      if (data.body.result == "SpclreasonFor" || this.validate("ExampleFormControlTextarea1", 0)) {
        this.showError = true;
        this.showErrorMsg = "No Special characters allowed.";
        // this.moveCursor("ExampleFormControlTextarea1");
        this.errorPrint("exampleFormControlTextarea1Error", "No Special characters allowed.");

        document.getElementById("ExampleFormControlTextarea1").style.backgroundColor = "#FFB280";


      }
      if (data.body.result == "Spclcaptcha" || this.validate("EnterCaptchaInputId", 0)) {
        this.showError = true;
        this.showErrorMsg = "No Special characters allowed.";
        // this.moveCursor("EnterCaptchaInputId");
        this.errorPrint("enterCaptchaInputIdError", "No Special characters allowed.");

        document.getElementById("EnterCaptchaInputId").style.backgroundColor = "#FFB280";

      }
      if (data.body.result == "success") {
        this.resultDto = data.body;
        refreshFlag = 0;
        //// console.log("resultDto===",this.resultDto)
        //this.mainDiv=false;
        //this.successDiv=true;
        this.showDiv = true;
        // // console.log("Yes flag");
        // this.router.navigate(['/successform']);
        this.showError = false;

      }
      if (data.body.result == "fail") {
        // this.captcha();
        this.showError = true;
        // this.showErrorMsg = "LOA details are not matched.";

        if (null != this.obj.loaId || this.obj.loaId != "") {
          document.getElementById("LoaInputId").style.backgroundColor = "#FFB280";
          // this.moveCursor("LoaInputId");
          this.errorPrint("loaInputIdError", "LOA ID is invalid");
          this.showErrorMsg = "LOA ID is invalid"
        }
        if (null != this.obj.loaHolderName || this.obj.loaHolderName != "") {
          document.getElementById("LoaHolderInputId").style.backgroundColor = "#FFB280";
          // this.moveCursor("LoaHolderInputId");
          this.errorPrint("loaHolderInputIdError", "LOA Holder Name is invalid");

          this.showErrorMsg = "LOA Holder Name is invalid"
        }
      }
      if (data.body.result == "wrongCaptcha") {
        // this.captcha();
        this.showError = true;
        this.showErrorMsg = "The CAPTCHA letters entered do not match.";

        if (null != this.enterCaptchaImage || this.enterCaptchaImage != "") {
          document.getElementById("EnterCaptchaInputId").style.backgroundColor = "#FFB280";
          // this.moveCursor("EnterCaptchaInputId");
          this.errorPrint("enterCaptchaInputIdError", "The CAPTCHA letters entered do not match.");

        }
      }
      if (data.body.result == "blankValue") {
        // this.captcha();
        this.showError = true;
        // this.showErrorMsg = "Please fill the highlighted fields.";
        if (null == this.obj.name || this.obj.name == "") {

          document.getElementById("Namee").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "Please enter the name.";
          // this.moveCursor("Namee");
          this.errorPrint("nameeError", "Please enter the name.");
        }
        if (null == this.obj.company || this.obj.company == "") {

          document.getElementById("CompanyInputId").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "Please enter the company name.";
          // this.moveCursor("CompanyInputId");
          this.errorPrint("companyInputIdError", "Please enter the company name.");
        }
        if (null == this.obj.emailId || this.obj.emailId == "") {

          document.getElementById("MailId").style.backgroundColor = "#FFB280";
          // this.showErrorMsg = "Please enter the mail id.";
          // this.moveCursor("MailId");
          this.errorPrint("mailIdError", "Please enter the mail id.");
        }
        if (null == this.obj.countryCode || this.obj.countryCode == "" || (this.obj.countryCode.charAt(0)=="+" && this.obj.countryCode.length==1)) {

          document.getElementById("CountryInputId").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "Please enter the country code.";
          // this.moveCursor("CountryInputId");
          this.errorPrint("countryInputIdError", "Please enter the country code.");
        }
        if (null == this.obj.phoneNo || this.obj.phoneNo == "") {

          document.getElementById("PhoneNoInputId").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "Please enter the phone number.";
          // this.moveCursor("PhoneNoInputId");
          this.errorPrint("phoneNoInputIdError", "Please enter the phone number.");
        }
        if (null == this.obj.loaId || this.obj.loaId == "") {

          document.getElementById("LoaInputId").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "Please enter the LOA Id.";
          // this.moveCursor("LoaInputId");
          this.errorPrint("loaInputIdError", "Please enter the Letter of Authority Id.");

        }
        if (null == this.obj.loaHolderName || this.obj.loaHolderName == "") {

          document.getElementById("LoaHolderInputId").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "Please enter the LOA Holder name.";
          // this.moveCursor("LoaHolderInputId");
          this.errorPrint("loaHolderInputIdError", "Please enter the Letter of Authority Holder name.");

        }
        if (null == this.obj.reasonForValidating || this.obj.reasonForValidating == "") {

          document.getElementById("ExampleFormControlTextarea1").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "Please enter the reason for validating.";
          // this.moveCursor("ExampleFormControlTextarea1");
          this.errorPrint("exampleFormControlTextarea1Error", "Please enter the reason for validating.");

        }
        if (null == this.obj.enterCaptcha || this.obj.enterCaptcha == "") {

          document.getElementById("EnterCaptchaInputId").style.backgroundColor = "#FFB280";
          this.showErrorMsg = "Please enter the captcha.";
          // this.moveCursor("EnterCaptchaInputId");
          this.errorPrint("enterCaptchaInputIdError", "Please enter the captcha.");

        }
      }
      if (this.newCaptchaAlert()) {
        if (null != this.enterCaptchaImage || this.enterCaptchaImage != "") {
          document.getElementById("EnterCaptchaInputId").style.backgroundColor = "#FFB280";
          // this.moveCursor("EnterCaptchaInputId");
          this.errorPrint("enterCaptchaInputIdError", "Please enter the new captcha");
        }
      }

      if (refreshFlag == 1) {
        this.captcha();
      }
      if (this.errorFields.length > 0) {
        // console.log("Error Field", this.errorFields);
        // let firstError = (this.errorFields[0].charAt(0).toUpperCase()).concat(this.errorFields[0].substring(1, this.errorFields[0].length - 5));
        try {
          // console.log("SelectingFirstError", this.selectingFirstError());
          this.moveCursor(this.selectingFirstError());
        } catch (error) {

        }
        this.errorFields = [];
        // if(this.err)
      }
    },
    error: (error) => {
      // Handle error
      console.log("Error from Server==>>", error);
      this.captcha();
      alert("Something Went Wrong..!!");
    }
  })
  }

  selectingFirstError(): string {
    let errorField: string[] = ["nameeError", "companyInputIdError", "mailIdError", "countryInputIdError", "phoneNoInputIdError", "loaInputIdError", "loaHolderInputIdError", "exampleFormControlTextarea1Error", "enterCaptchaInputIdError"];
    let index: number[] = [];
    for (let i = 0; i < this.errorFields.length; i++) {
      for (let j = 0; j < errorField.length; j++) {
        if (this.errorFields[i] == errorField[j]) {
          index.push(j);
        }
      }
    }

    index.sort((a, b) => a - b);
    // console.log(index);
    let firstError = (errorField[index[0]].charAt(0).toUpperCase()).concat(errorField[index[0]].substring(1, errorField[index[0]].length - 5));
    return firstError;
  }

  ResetForm() {
    this.hideError();
    // this.resetFlag=false;
    this.speak("end");
    this.obj = new loaformObj();
    this.showError = false;
    document.getElementById('Namee').style.backgroundColor = "#FFFFFF";
    document.getElementById("CompanyInputId").style.backgroundColor = "#FFFFFF";
    document.getElementById("MailId").style.backgroundColor = "#FFFFFF";
    document.getElementById("CountryInputId").style.backgroundColor = "#FFFFFF";
    document.getElementById("PhoneNoInputId").style.backgroundColor = "#FFFFFF";
    document.getElementById("LoaInputId").style.backgroundColor = "#FFFFFF";
    document.getElementById("LoaHolderInputId").style.backgroundColor = "#FFFFFF";
    document.getElementById("ExampleFormControlTextarea1").style.backgroundColor = "#FFFFFF";
    document.getElementById("EnterCaptchaInputId").style.backgroundColor = "#FFFFFF";
    this.captcha();
    this.moveCursor("Namee")
    // this.alertText.nativeElement.textContent = 'Reset Completed';
    this.infoAlert = true;
    setTimeout(() => {
      this.alertText.nativeElement.textContent = '';
      this.infoAlert = false;
    }, 3000);
  }
  back() {
    this.showDiv = false;
    this.obj = new loaformObj();
    this.captcha();
  }

  moveCursor(idName: string) {
    // console.log("Moved field", idName)
    let id = document.getElementById(idName) as HTMLInputElement;
    id.focus();
    id.setSelectionRange(id.value.length, id.value.length);
  }

  errorPrint(id: string, msg: string) {
    // console.log("Readout", id);
    this.errorFields.push(id);
    let element: HTMLParagraphElement = document.getElementById(id) as HTMLParagraphElement;
    element.removeAttribute("hidden");
    element.innerText = msg;
    // // console.log("MSG..", msg);
  }

  hideError() {
    let element: HTMLCollection = document.getElementsByClassName("error-p") as HTMLCollection;
    for (let i = 0; i < element.length; i++) {
      element.item(i).setAttribute("hidden", "true");
    }
  }

  OpenPrivacyNotice() {
    this.privacyNotice = 'block';
  }
  closePrivacyModal() {
    this.privacyNotice = 'none';
  }
  onDown() {
    return false;
  }

  //Added by Nikhil for Accessibility Issue Resolution
  screenReader(x: any) {
    let textbox = document.getElementById("ExampleFormControlTextarea1");
    if (x == 600) {
      textbox.role = "document";
    }
    else {
      textbox.role = "textbox";
    }
  }

  onFocusAlert(id: string) {
    if (this.isAppInitialized && this.isValidated) {
      let element: HTMLParagraphElement = document.getElementById(id) as HTMLParagraphElement;
      element.setAttribute("role", "alert");
    }
  }
  onUnfocusAlert(id: string) {
    if (this.isAppInitialized && this.isValidated) {
      let element: HTMLParagraphElement = document.getElementById(id) as HTMLParagraphElement;
      element.removeAttribute("role");
    }
  }

  validate(id: string, flag: number): boolean {
    let field: HTMLInputElement = document.getElementById(id) as HTMLInputElement;


    if (id == "Namee" || id == "CompanyInputId" || id == "LoaHolderInputId" || id == "ExampleFormControlTextarea1" || id == "EnterCaptchaInputId") {
      let test = field.value;
      let matches: RegExpMatchArray | null = test.match("[<>,!@#$%^*()?\"]+");
      // console.log("Matches Namee", matches);
      if (matches != null) {
        return true;
      }
    }

    if (id == "MailId") {
      let test: string = field.value;
      let matches: RegExpMatchArray | null = test.match("[<>,!#$%^&*()?\"]+");
      // console.log("Matches Namee", matches);

      let atpos: number = test.indexOf("@");
      let dotpos: number = test.lastIndexOf(".");
      if (matches != null && test != "") {
        return true;
      } else if ((atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= test.length) && (flag == 1) && (test != "")) {
        return true;
      }
    }

    if (id == "CountryInputId") {
      let test = field.value;
      let matches: RegExpMatchArray | null = test.match("^[0-9+]*$");
      // console.log("Country code Matches", matches);
      if (matches == null) {
        return true;
      }
    }

    if (id == "PhoneNoInputId") {
      let test = field.value;
      let matches: RegExpMatchArray | null = test.match("^[0-9]*$");
      // console.log("Country code Matches", matches);
      if (test.length != 0 && matches == null && flag == 0) {
        return true;
      }

      if (test.length != 0 && test.length > 100 && flag == 1) {
        return true;
      }
    }

    return false;
  }

  newCaptchaAlert(): boolean {
    for (let i = 0; i < this.errorFields.length; i++) {
      if (this.errorFields[i] == "enterCaptchaInputIdError") {
        return false;
      }
    }
    return true;
  }

}
